export const Badge = ({ size = 48, className = "", ...rest }) => (
  <img
    src="/assets/badge.jpg"
    alt="Educate II Elevate badge"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className={`shrink-0 rounded-md object-cover object-[50%_33%] ${className}`}
    {...rest}
  />
);
